var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceproviders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.332 17.5V15.8333C13.332 14.9493 12.9808 14.1014 12.3557 13.4763C11.7306 12.8512 10.8828 12.5 9.9987 12.5H4.16536C3.28131 12.5 2.43346 12.8512 1.80834 13.4763C1.18322 14.1014 0.832031 14.9493 0.832031 15.8333V17.5M16.6654 6.66667V11.6667M19.1654 9.16667H14.1654M10.4154 5.83333C10.4154 7.67428 8.92298 9.16667 7.08203 9.16667C5.24108 9.16667 3.7487 7.67428 3.7487 5.83333C3.7487 3.99238 5.24108 2.5 7.08203 2.5C8.92298 2.5 10.4154 3.99238 10.4154 5.83333Z",
    stroke: "#FF456E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceproviders);
export default __webpack_public_path__ + "static/media/serviceproviders.859a06ae7f9a8a6825de0be56703130b.svg";
export { ForwardRef as ReactComponent };